import ShopMyStoreChiclet from 'components/ShopYourStore/ShopMyStoreChiclet/ShopMyStoreChiclet';
import { withShopMyStoreChicletProps } from 'components/ShopYourStore/ShopMyStoreChiclet/withShopMyStoreChicletProps';

export default withShopMyStoreChicletProps(ShopMyStoreChiclet);
